export const PAYMENT_INITIAL = "PAYMENT_INITIAL";//payMent initial
export const BILLIN_HISTORY_INITIAL = "BILLIN_HISTORY_INITIAL";//billingHistory Initial
